<div>
    <div class="p-b-24 text-center" style="background: #F9F9FB;border-radius: 16px;">
        <img src="assets/images/copylink.png" width="90%" style="max-width: 300px;">
    </div>

    <div class="m-t-10 m-b-20 font-h6 text-center">
        Copiá el link y se lo compartís por Whatsapp o cualquier otro medio
    </div>

    <div class="m-t-10 m-b-20" [ngClass]="{'has-danger': !transactionNote && transactionNoteInput.touched}">
        <label class="text-muted">¿Para quién es el regalo? *</label>
        <input #transactionNoteInput="ngModel" class="w-100 font-12" [(ngModel)]="transactionNote" required>
        <div *ngIf="!transactionNote && transactionNoteInput.touched" class="form-control-feedback">
            <small>Este campo es requerido</small>
        </div>
    </div>

    <div class="m-b-20">
        <input id="givi-link" class="w-100 font-12" readonly="true" [value]="givilink">

        <label *ngIf="linkCopied" class="text-to-copy text-primary font-11">Link Copiado</label>
    </div>


    <div class="d-flex-center">
        <button type="button" class="btn-dark-custom" (click)="onCopyLink()" [disabled]="!transactionNote || linkCopied ">Copiar Link</button>
    </div>

    <!-- Este input esta escondido, se usa para copiar al clipboard -->
    <input id="givi-output" class="text-invisible">
</div>